import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import productDeleteModalStyles from "./ProductDeleteModal.styles";

const ProductDeleteModal = ({ open, onClose, onConfirm, productId }) => {
  const styles = productDeleteModalStyles;

  const handleConfirm = () => {
    onConfirm(productId);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.deleteModalContent}>
        <Typography sx={styles.deleteModalTitle}>
          Delete Product?
        </Typography>
        <Typography sx={styles.deleteModalText}>
          Are you sure you want to delete this product?
        </Typography>
        <Box sx={styles.deleteModalBtns}>
          <Button
            variant='outlined'
            color='primary'
            sx={styles.deleteModalCancelBtn}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            sx={styles.deleteModalYesBtn}
            onClick={handleConfirm}
          >
            Yes, Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ProductDeleteModal;

